<template>
  <div>
    <div class="question-area">

      <ProductsViewer
          v-if="survey.survey_type === 'visual_ranking'"
          ref="image_with_products"
          class="image-with-products"
          :item-size="25"
          :item-stroke-width="25"
          :show-tooltips="true"
          :show-products="show_products"
          :question="question"
          @product-click="onProductClick"
          @stage-click="onStageClick(question)"
      ></ProductsViewer>

      <div v-if="survey.survey_type === 'narrative_ranking'" class="narrative_ranking">
        <img v-if="question.thumbnail" :src="question.thumbnail"/>
        <p>{{ question.text }}</p>
      </div>

      <template
          v-if="question.type === 'select-multiple' ||
                question.type === 'radio' ||
                question.type === 'text' ||
                question.type === 'select_image_from_list'">
        <QuestionContent
            ref="question_content"
            :cur_pos="cur_pos"
            :max_pos="max_pos"
            :questions="questions"
            @skip="doSkip"
            @answer="doAnswer">
        </QuestionContent>
      </template>

    </div>

    <Buttons
        :show-products-btn="survey.is_visual_ranking_survey"
        :question="question"
        :is-first="cur_pos === 0"
        :is-last="cur_pos === max_pos"
        :is-visual-survey="survey.is_visual_ranking_survey"
        :disable-required="survey.survey_type !== 'custom_variables'"
        @next="$emit('next')"
        @prev="$emit('prev')"
        @answer="doAnswer"
        @endSurvey="$emit('endSurvey')"
        @toggleProducts="doToggleProducts"
    ></Buttons>
  </div>
</template>
<script>
import ProductsViewer from '@src/components/products/ProductsViewer.vue'
import Buttons from '@src/components/survey/Buttons.vue'
import QuestionContent from '@src/components/survey/QuestionContent.vue'

export default {
  components: {
    Buttons,
    ProductsViewer,
    QuestionContent
  },
  props: {
    questions: Array,
    question: Object,
    survey: Object,
    max_pos: Number,
    cur_pos: Number,
  },
  data() {
    return {
      show_products: false,
    }
  },
  methods: {
    onProductClick(p_id) {
      this.$emit('product_click', p_id)
    },
    onStageClick(question) {
      this.$emit('stage_click', question)
    },
    doAnswer(val, question_type) {
      this.$emit('answer', val, question_type)
    },
    doSkip() {
      this.$emit('skip')
    },
    doToggleProducts() {
      this.show_products = !this.show_products
      this.$refs.image_with_products.showHideProducts(this.show_products)
    },
  },
}
</script>
<style lang="scss" scoped>
.question {
  flex: 1;
  height: 90vh;

  .canvas-wrapper {
    flex: 1;
    min-height: 100%;
  }
}

.question-area {
  margin-top: 10px;
  display: flex;
  flex-grow: 1;
  height: 100%;
}

.control-panel {
  margin-bottom: 30px;
}


.question-area {
  align-items: center;
  width: 100%;


  .narrative_ranking {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: 1px solid silver;

    margin-top: 35px;


    img {
      width: 200px;
    }

    p {
      margin: 0px;
      height: auto;
      font-size: 30px;
      color: gray;
      line-height: 1.5em;
      width: 100%;
      padding: 15px;
    }
  }

  @media only screen and (max-width: 768px) {
    .narrative_ranking {
      flex-direction: column;

      img {
        margin-bottom: 25px;
      }
    }
  }

}
</style>
